import Avatar from 'material-ui/Avatar/Avatar';
import FancyAvatar from './FancyAvatar';

export { FancyAvatar };
export default Avatar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Avatar/index.ts